import React from "react";
import { Link } from "react-router-dom";

export default function WhatWeDo() {
    return (
        <>
        <section className="section section--soft">
            <div className="container">
                <div className="svc-head">
                    <div>
                        <div className="eyebrow">What we do</div>
                        <h2 className="h-lg">Full-stack expertise, one accountable team.</h2>
                    </div>
                    <Link to="/services" className="more">
                        All services →
                    </Link>
                </div>
                <div className="svc-grid">
                    <Link to="/custom-php-software-solutions" className="svc-feature card">
                        <span className="blob"></span>
                        <div>
                            <div className="ico">
                                <svg fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.9" viewBox="0 0 24 24"><polyline points="16 18 22 12 16 6"></polyline><polyline points="8 6 2 12 8 18"></polyline></svg>
                            </div>
                            <span className="badge">FLAGSHIP SERVICE</span>
                            <h3>Custom Solutions Development</h3>
                            <p>Bespoke software, platforms and integrations engineered around your exact workflow — architected to scale as you grow, not to fit a template.</p>
                        </div>
                        <span className="go">Explore custom development →</span>
                    </Link>
                    <Link to="/website-design-&-development" className="svc-tile card card-bordered">
                        <div className="ico">
                            <svg fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.9" viewBox="0 0 24 24"><rect height="14" rx="2" width="20" x="2" y="3"></rect><path d="M8 21h8"></path><path d="M12 17v4"></path></svg>
                        </div>
                        <h3>Web Design &amp; Development</h3>
                        <p>Fast, responsive, conversion-focused sites built end to end.</p>
                    </Link>
                    <Link to="/wordpress-development" className="svc-tile card card-bordered">
                        <div className="ico">
                            <svg fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.9" viewBox="0 0 24 24"><path d="M12 19l7-7 3 3-7 7-3-3z"></path><path d="M18 13l-1.5-7.5L2 2l3.5 14.5L13 18z"></path><path d="M2 2l7.586 7.586"></path><circle cx="11" cy="11" r="2"></circle></svg></div>
                        <h3>WordPress Development</h3>
                        <p>Custom themes and plugins your team can actually manage.</p>
                    </Link>
                    <Link to="/woocommerce-development" className="svc-tile card card-bordered">
                        <div className="ico">
                            <svg fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.9" viewBox="0 0 24 24"><circle cx="8" cy="21" r="1"></circle><circle cx="19" cy="21" r="1"></circle><path d="M2.05 2.05h2l2.66 12.42a2 2 0 0 0 2 1.58h9.78a2 2 0 0 0 1.95-1.57l1.65-7.43H5.12"></path></svg>
                        </div>
                        <h3>E-Commerce &amp; WooCommerce</h3>
                        <p>Storefronts and checkouts tuned to sell and scale.</p>
                    </Link>
                    <Link to="/react-js-development" className="svc-tile card card-bordered">
                        <div className="ico">
                            <svg fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.9" viewBox="0 0 24 24"><rect height="20" rx="2" width="14" x="5" y="2"></rect><path d="M12 18h.01"></path></svg></div>
                        <h3>React &amp; App Development</h3>
                        <p>Component-driven front ends that feel like products.</p>
                    </Link>
                </div>
                <div className="svc-grid">
                    <Link to="/digital-marketing-services" className="svc-wide card card-bordered">
                        <div className="ico">
                            <svg fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.9" viewBox="0 0 24 24"><path d="m3 11 18-5v12L3 14v-3z"></path><path d="M11.6 16.8a3 3 0 1 1-5.8-1.6"></path></svg>
                        </div>
                        <div>
                            <h3>Digital Marketing — SEO, PPC &amp; Social</h3>
                            <p>Get your work in front of the right people, then keep them coming back.</p>
                        </div>
                    </Link>
                    <Link to="/website-monitoring-and-maintenance" className="svc-wide span2 card card-bordered">
                        <div className="ico">
                            <svg fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.9" viewBox="0 0 24 24"><circle cx="12" cy="12" r="10"></circle><circle cx="12" cy="12" r="4"></circle><line x1="4.93" x2="9.17" y1="4.93" y2="9.17"></line><line x1="14.83" x2="19.07" y1="14.83" y2="19.07"></line><line x1="14.83" x2="19.07" y1="9.17" y2="4.93"></line><line x1="4.93" x2="9.17" y1="19.07" y2="14.83"></line></svg>
                        </div>
                        <div>
                            <h3>Maintenance &amp; Support</h3>
                            <p>Proactive care that keeps everything fast, secure and current.</p>
                        </div>
                    </Link>
                </div>
            </div>
        </section>
        </>
    )
}